module.exports = __webpack_public_path__ + "static/media/left-chevron-icon.a0c9eb27.svg";